export default {
  init() {
    // JavaScript to be fired on the corona page
    // var width = $(window).width();
    // if (width < 768) {
    //   var showWords = 50;
    //   var ellipsestext = '';
    //   var moretext = 'Read More';
    //   var lesstext = 'Read Less';
    //   $('.more').each(function () {
    //     var content = $(this).html();
    //     var regex = /\s+/gi;
    //     var numberWords = content.trim().split(regex).length;
    //     var tenWords = content.trim().split(regex, showWords).join(' ');
    //     var contentFull = content.trim().split(regex).join(' ');
    //     if (numberWords > showWords) {
    //       var remainWords = contentFull.substr(
    //         tenWords.length,
    //         contentFull.length - tenWords.length
    //       );
    //       var html =
    //         tenWords +
    //         '<span class="lvr-moreellipses">' +
    //         ellipsestext +
    //         '</span><span class="lvr-morecontent"><span>' +
    //         remainWords +
    //         '</span>&nbsp;&nbsp;<a href="" class="lvr-morelink">' +
    //         moretext +
    //         '</a></span>';
    //       $(this).html(html);
    //     }
    //   });
    //   $('.lvr-morelink').click(function () {
    //     if ($(this).hasClass('lvr-less')) {
    //       $(this).removeClass('lvr-less');
    //       $(this).html(moretext);
    //     } else {
    //       $(this).addClass('lvr-less');
    //       $(this).html(lesstext);
    //     }
    //     $(this).parent().prev().toggle();
    //     $(this).prev().toggle();
    //     return false;
    //   });
    // }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/corona.js